import React, { useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/authStore';
import { useProjectStore } from './store/projectStore';

// Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Dashboard from './pages/Dashboard';
import InterviewPage from './pages/InterviewPage';
import ThankYouPage from './pages/ThankYouPage';
import SuperAdminDashboard from './pages/SuperAdminDashboard';

// Components
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const { user } = useAuthStore();
  const { fetchProjects, fetchProspects } = useProjectStore();

  // Initial data loading
  useEffect(() => {
    // Load data from Supabase when app starts
    console.log("App started, fetching initial data...");
    
    const loadInitialData = async () => {
      try {
        console.log("Fetching projects...");
        await fetchProjects();
        console.log("Fetching prospects...");
        // Uncomment when prospects table is ready
        // await fetchProspects();
        console.log("Initial data loaded successfully");
      } catch (error) {
        console.error("Error loading initial data:", error);
      }
    };
    
    loadInitialData();
  }, [fetchProjects, fetchProspects]);

  return (
    <HashRouter>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/interview/:id" element={<InterviewPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />

          {/* Protected Routes */}
          <Route path="/dashboard/*" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />

          {/* Super Admin Routes */}
          <Route path="/superadmin/*" element={
            <ProtectedRoute requiredRole="superadmin">
              <SuperAdminDashboard />
            </ProtectedRoute>
          } />

          {/* Redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </div>
    </HashRouter>
  );
}

export default App;